import {Component, OnInit, OnDestroy, Input, inject, DestroyRef} from '@angular/core';
import { EquipmentService } from './equipment.service';
import { SupplierOutletService } from '../app-shared/services/supplier-outlet.service';
import { SettingsService } from '../app-shared/services/settings.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { SelectedUserSuppliersAndOutlets } from '../app-shared/models/supplier-outlet.model';
import { StorageService } from '../app-shared/services/storage.service';
import { EquipmentSupOutModel } from './equipment.model';
import { CatalogService } from '../catalog/catalog.service';
import { AuthUser, MainUserService } from '../app-shared';
import { HeaderService } from '../app-shared/services/header.service';
import {UserAdminService} from "../profile/profile-shared/services/user-admin.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-equipment',
    templateUrl: './equipment.component.html',
    styleUrls: ['./equipment.component.scss'],
    standalone: false
})
export class EquipmentComponent implements OnInit, OnDestroy {
  @Input() mobile: boolean;

  equipmentArray: Array<EquipmentSupOutModel> = [];
  selectedItem: EquipmentSupOutModel;
  private readonly destroyRef = inject(DestroyRef);
  showMessage: boolean = false;
  userData: AuthUser;
  isLoading: boolean;
  constructor(
    private equipmentService: EquipmentService,
    public supplierOutletService: SupplierOutletService,
    public settings: SettingsService,
    public header: HeaderService,
    private storageService: StorageService,
    private catalogService: CatalogService,
    private mainUserService: MainUserService,
    private userAdminService: UserAdminService,
  ) {
    this.userData = this.mainUserService.getUserData();
  }

  ngOnInit(): void {
    this.subscribeToEquipment();
    this.checkChangeSupplierAndOutlets();
    this.userAdminService.addCssClassForContainerHeight(true);
  }

  private subscribeToEquipment(): void {
    this.isLoading = true;
    this.equipmentService.getEquipmentByOutlet()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next: (res) => {
        this.equipmentArray = res.map(item => {
          const supAndOutlets = JSON.parse(this.storageService.getFromLocalStorage('selectedUserSuppliersAndOutlets'));
          return {
            ...item,
            externalCode: supAndOutlets.externalCode,
            address: supAndOutlets.address
          };
        });
        this.setInitialSelectedItem();
        this.isLoading = false;
      },
      error: () => {
        this.equipmentArray = [];
        this.isLoading = false;
      },
    });
  }

  private setInitialSelectedItem(): void {
    const supAndOutlets: SelectedUserSuppliersAndOutlets = JSON.parse(this.storageService.getFromLocalStorage('selectedUserSuppliersAndOutlets'));
    this.selectedItem = this.equipmentArray.find(x => x.supplierId === supAndOutlets.supplierId && x.outletId === supAndOutlets.outletId);
    if (this.selectedItem) {
      this.selectedItem.externalCode = supAndOutlets.externalCode;
      this.selectedItem.address = supAndOutlets.address;
    }
    this.showMessage = !this.selectedItem;

    this.updateHeader();
  }

  private checkChangeSupplierAndOutlets(): void {
    this.catalogService.changeSuppierAndOutlet
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.userData = this.mainUserService.getUserData(); // Update userData here
        const supAndOutlets: SelectedUserSuppliersAndOutlets = JSON.parse(
          this.storageService.getFromLocalStorage('selectedUserSuppliersAndOutlets')
        );
        this.selectItemBasedOnSupplierAndOutlet(supAndOutlets.supplierId, supAndOutlets.outletId);
      });
  }

  private selectItemBasedOnSupplierAndOutlet(supplierId: number, outletId: number): void {
    const supAndOutlets: SelectedUserSuppliersAndOutlets = JSON.parse(this.storageService.getFromLocalStorage('selectedUserSuppliersAndOutlets'));
    this.selectedItem = this.equipmentArray.find(
      (item) => item.supplierId === supplierId && item.outletId === outletId
    );

    if (this.selectedItem) {
      this.selectedItem.externalCode = supAndOutlets.externalCode;
      this.selectedItem.address = supAndOutlets.address;
    }
    this.showMessage = !this.selectedItem;

    this.updateHeader();
  }

  private updateHeader(): void {
    this.header.updateSettingHeader({
      title: '',
      isCart: true,
      hideHeader: false,
      hideSubHeader: false,
    });
  }

  ngOnDestroy(): void {
    this.userAdminService.addCssClassForContainerHeight(false);
  }
}
